import { Clients, createApiClients } from '@xiag-search/sdk';

export async function getClients(
    apiKey: string,
    domain: string,
): Promise<Clients> {
    return Promise.resolve(createApiClients({ apiKey, domain }));
}
